import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Setting = {
  setting_id?: number; // 설정 idx
  admin_id?: number; // 관리자 idx
  cart_setting?: { [key: string]: string | number }; // 장바구니 설정
  seo_setting?: { [key: string]: string | number }; // 검색엔진 최적화 설정
  order_reservation_setting?: { [key: string]: string | number }; // 주문 취소 관리 설정
  parcel_service_setting?: { [key: string]: string | number }; // 정기배송 정책 관리 설정
  rental_setting?: { [key: string]: string | number }; // 렌탈 정책 관리 설정
  product_setting?: { [key: string]: string | number }; // 상품 정렬 설정
  stamp_setting?: { [key: string]: string | number }; // 스탬프 설정
  notification_setting?: { [key: string]: string | number }; // 자동알림 설정
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Setting
   * --
   */
  getSettings: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SETTING, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Setting
   * --
   */
  getSetting: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SETTING, { setting_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Setting
   * --
   */
  createSetting: async (body: Setting) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SETTING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Setting
   * --
   */
  updateSetting: async (body: Setting) => {
    try {
      const { setting_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SETTING, {
        setting_id: setting_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Setting
   * --
   */
  deleteSetting: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SETTING, {
        setting_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
